import { useSelector } from 'modules/react-redux';
import { useGetRecognizedOcrAttachment } from 'pages/requestForm/hooks/useGetRecognizedOcrAttachment';
import { useOcrData } from 'pages/requestForm/hooks/useOcrData';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { FC, memo } from 'react';
import { useGetNetSuiteSubsidiaries } from 'shared/data/webApp/v1';

import { Loading, NetSuiteVendorCreationPopupForm } from './components';
import { messages } from './NetSuiteVendorCreationPopupContent.messages';
import { NetSuiteVendorCreationPopupContentProps } from './NetSuiteVendorCreationPopupContent.types';

export const NetSuiteVendorCreationPopupContent: FC<NetSuiteVendorCreationPopupContentProps> = memo((props) => {
    const request = useSelector(requestSelector);

    const ocrAttachment = useGetRecognizedOcrAttachment(request);

    const { data: ocrData, isFetching: isOcrFetching } = useOcrData(request, ocrAttachment?.id);

    const { data: subsidiaryReferenceList, isFetching: isSubsidiariesFetching } = useGetNetSuiteSubsidiaries({
        query: {
            companyId: request.companyId,
        },
    });

    if (isSubsidiariesFetching || isOcrFetching) {
        return <Loading popupTitle={messages.popupTitle} />;
    }

    return (
        <NetSuiteVendorCreationPopupForm
            {...props}
            subsidiaries={subsidiaryReferenceList?.values || []}
            popupTitle={messages.popupTitle}
            ocrData={ocrData}
        />
    );
});

NetSuiteVendorCreationPopupContent.displayName = 'NetSuiteVendorCreationPopupContent';
